import AmpService, { AMP_CATEGORY_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import useScreenSize from "hoc/useScreenSize";
import LazyBackgroundImage from "modules/lazy-background-image/LazyBackgroundImage";
import { useTranslation } from "next-i18next";
// import HideIf from "util/HideIf";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import imageUrls from "resources/json/spriteImageUrl.json";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { toLowerCase } from "util/lodash/toLowerCase";
import { toKebabCase } from "../../util/lodash/toKebabCase";
import CategoryViewItem from "../categories-viewer/CategoryViewItem";
import HiddenButton from "../design-system/buttons/HiddenButton";
import HoverablePopoverTrigger from "./HoverablePopoverTrigger";
import PopoverComponent from "./PopoverComponent";
import styles from "./categoryItem.module.scss";

function CategoryItem(props: any) {
  const {
    t0, index, subCategory, closeToolbar, big_icon,
    isRegularService,
  } = props;
  const [, , isDesktop] = useScreenSize();
  const {
    subs, filters, t1, t2, t3, name, imageUrl, view,
    subsList, url: subCategoryUrl,
  } = subCategory;
  const { t } = useTranslation("category-map");

  const isMerch = toLowerCase(t0) === "merchandise";

  let countChildren = ((!isMerch && subs) ? subs.length : 0);
  if (filters) {
    countChildren = filters ? filters.length : 0;
  }

  let component = (
    <HiddenButton className={styles.hidden_button}>
      <div>
        <LazyBackgroundImage
          src={getRelativeImagePath(imageUrls[isRegularService ? "regular-service" : toKebabCase(t0)])}
          className={`${big_icon ? styles.big_icon : styles.small_icon} toolbar-category-sprite-icon`}
          style={{ backgroundPosition: `-0px -${(((big_icon ? 60 : 39) * index))}px`, borderRadius: "100%", position: "relative" }}
        />
      </div>
      <PAText color={t1 === "Sale" ? "pa-blue" : ""} className={`category-text text-capitalize ${big_icon ? styles.text_big : styles.text_small}`}>
        {t(name || t1)}
      </PAText>
      <i className={`fa icon-right fa fa-chevron-right ${styles.right_arrow}`} />
    </HiddenButton>
  );
  if (view === "list" && name) {
    const skipApi = name === "All Merch";
    component = (
      <div>

        <CategoryViewItem
          categoryObj={{
            tier0: t0,
            tier1: t1,
          }}
          skipApi={skipApi}
          url={subCategoryUrl}
        >
          {component}
        </CategoryViewItem>
        <div className={styles.list_view}>
          {subsList.map((eachSub: { name: string, url: string, popularSection?: boolean }) => {
            const { name: eachSubName, url, popularSection } = eachSub;
            return (
              <CategoryViewItem
                categoryObj={{
                  tier0: t0,
                  tier1: t1,
                  tier2: eachSub.t2,
                }}
                skipApi={skipApi}
                url={url}
              >
                <PAText className={popularSection ? styles.popular_section : ""}>
                  {t(eachSubName)}
                </PAText>
              </CategoryViewItem>
            );
          })}
        </div>
      </div>
    );
  } else if (!name && imageUrl) {
    component = (
      <div className={styles.default_card} />
    );
  } else if (imageUrl) {
    const src = getRelativeImagePath(`/cms/${imageUrl}`);
    component = (
      <div className={styles.big_image_container}>
        <PAImage src={src} height={250} width={250} />
        <div>
          <PAText fontSize={FONT_SIZE[2]}>
            {t(name || t1)}
          </PAText>

          <i className={`fa icon-right fa fa-chevron-right ${styles.right_arrow}`} />
        </div>
      </div>
    );
  }

  const children = (
    <div onClick={() => {
      if (closeToolbar) {
        closeToolbar();
      }
      AmpService.categoryClick({ tier0: t0, tier1: t1 }, AMP_CATEGORY_LOCATIONS.TOOLBAR);
    }}
    >
      {isMerch && (
        <>
          {component}
        </>
      )}
      {view !== "list" && (
        <CategoryViewItem
          categoryObj={{
            tier0: t0,
            tier1: t1,
            tier2: t2,
            tier3: t3,
          }}
        >
          {component}
        </CategoryViewItem>
      )}

    </div>
  );

  if (countChildren > 0 && isDesktop) {
    // placement left for last item in row.
    const placement = "right";
    return (
      <>
        <HoverablePopoverTrigger
          placement={placement}
          popover={(
            <PopoverComponent
              {...{ t0, t1, subCategory }}
              closeToolbar={closeToolbar}
            />
          )}
          popoverClassName={styles.hoverable_popover}
        >
          {children}
        </HoverablePopoverTrigger>
      </>
    );
  }
  return children;
}
export default CategoryItem;
